'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('linksoft/core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _keys3 = require('lodash/keys');

var _keys4 = _interopRequireDefault(_keys3);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _ContactForm = require('../cart/components/cartDetail/step3/ContactForm');

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

var _smartFormShared = require('../smartform/smartFormShared');

var _smartFormShared2 = _interopRequireDefault(_smartFormShared);

var _utils = require('../cart/components/utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('app:customer:actions');

var Resx = (0, _localize2.default)('Messages', 'Validation', 'App', 'Common');

var customerService = abp.services.api.customerB2c;
var addressService = abp.services.api.address;

var actions = {
    setMode: function setMode(mode) {
        return { type: _actionTypes2.default.SET_FORM_MODE, mode: mode };
    },

    editAddress: function editAddress(address) {
        return { type: _actionTypes2.default.EDIT_DELIVERY_ADDRESS, address: address };
    },

    saveAddress: function saveAddress(address) {
        return function (dispatch) {
            if (!address) return new _promise2.default(function (resolve) {
                return resolve();
            });
            return _promise2.default.resolve(addressService.saveAddress(address)).then(function (id) {
                return dispatch({ type: _actionTypes2.default.SELECT_DELIVERY_ADDRESS, id: id });
            })
            //.then(() => dispatch(actions.discardAddress()))
            .then(function () {
                return dispatch(actions.loadContact());
            }).catch(function (err) {
                return log('loadContact failed. %o', err);
            });
        };
    },

    loadContact: function loadContact() {
        return function (dispatch) {
            customerService.getContactInfo().done(function (c) {
                dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: toClientModel(c) });
            }).fail(function (err) {
                log('loadContact failed. %o', err);
            });
        };
    },
    changeContact: function changeContact(contact) {
        return function (dispatch, getState) {
            dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
            var state = getState();

            actions.checkAllZipCodes(state, dispatch, contact);
            actions.checkDuplicateNumber(state, dispatch, contact);

            // re-validate on change only after user clicked submit button first
            if (state.customer.contactErrors.hasClientErrors) {
                dispatch(actions.validate());
            }
        };
    },

    checkAllZipCodes: function checkAllZipCodes(state, dispatch, contact) {
        try {
            var _state$customer$conta = state.customer.contact,
                postCode = _state$customer$conta.postCode,
                street = _state$customer$conta.street,
                keepZipByUser = _state$customer$conta.keepZipByUser,
                deliveryAddress = _state$customer$conta.deliveryAddress;

            var deliveryAddressNew = contact.deliveryAddress;

            if (deliveryAddress && deliveryAddressNew) {
                postCode = deliveryAddress.postCode;
                street = deliveryAddress.street;
            }

            var zipRegex = /[0-9]{3}\s?[0-9]{2}/;
            var extractedZip = zipRegex.exec(postCode) || [];
            var extractedZipInStreet = zipRegex.exec(street) || [];

            // first check, if fixing street value was not declined by user previously 
            // and check if there is some string in ZIP code format  
            if (keepZipByUser || extractedZip.length !== 1 && extractedZipInStreet.length < 1) {
                return;
            }

            var zip = extractedZip[0].replace(' ', '');
            var zipsInStreet = extractedZipInStreet.map(function (z) {
                return z.replace(' ', '');
            });
            var rx = Resx.Messages;

            if (zipsInStreet.indexOf(zip) < 0) return;

            sweetAlert(actions.getWarningAlertObject(rx.DuplicateZipCodeConfirmCaption, rx.DuplicateZipCodeConfirmMessage), function (isConfirmed) {
                if (isConfirmed) {
                    var newStreetValue = street;
                    // remove all zipcodes found as same as value for zipcode input 
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)(extractedZipInStreet), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var replacement = _step.value;

                            newStreetValue = newStreetValue.replace(replacement, '');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    actions.updateStreetValue(newStreetValue, deliveryAddress, deliveryAddressNew, contact, dispatch);
                } else {
                    contact.keepZipByUser = true;
                    dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
                }
            });
        } catch (e) {
            console.error(e);
        }
    },

    checkDuplicateNumber: function checkDuplicateNumber(state, dispatch, contact) {
        try {
            var _state$customer$conta2 = state.customer.contact,
                street = _state$customer$conta2.street,
                keepDoubleNumberByUser = _state$customer$conta2.keepDoubleNumberByUser,
                deliveryAddress = _state$customer$conta2.deliveryAddress;

            var deliveryAddressNew = contact.deliveryAddress;

            if (deliveryAddress && deliveryAddressNew) {
                street = deliveryAddress.street;
            }

            var rx = Resx.Messages;
            var streetNumberRegex = /[0-9]+[\\/]?[0-9]*/g;
            var streetNumberArray = (street || '').match(streetNumberRegex);

            // first check, if fixing street number value was not declined by user previously 
            // and check if there is not duplicated number in street input
            if (keepDoubleNumberByUser || !streetNumberArray || streetNumberArray.length < 1) {
                return;
            }

            var duplicatedNumbers = {};
            for (var i = 0; i < streetNumberArray.length; i++) {
                var num = streetNumberArray[i];
                var index = streetNumberArray.indexOf(num);

                if (index > -1 && i !== index) {
                    duplicatedNumbers[num] = (duplicatedNumbers[num] || 1) + 1;
                }
            }

            var dupNumbers = (0, _keys2.default)(duplicatedNumbers);
            if (dupNumbers.length <= 0) return;

            var alertMessage = rx.DuplicateNumberInStreetMessage.replace('%duplicate_numbers%', dupNumbers.join(', '));

            sweetAlert(actions.getWarningAlertObject(rx.DuplicateNumberInStreetCaption, alertMessage), function (isConfirmed) {
                if (isConfirmed) {
                    var newStreetValue = street;
                    // remove duplicated numbers 
                    for (var replacement in duplicatedNumbers) {
                        // start from 1 means keep the first one, remove others
                        for (var j = 1; j < duplicatedNumbers[replacement]; j++) {
                            // looks weird ha? but reverse is here from removing 
                            newStreetValue = _common2.default.reverseString(newStreetValue).replace(_common2.default.reverseString(replacement), '');
                            newStreetValue = _common2.default.reverseString(newStreetValue);
                        }
                    }
                    actions.updateStreetValue(newStreetValue, deliveryAddress, deliveryAddressNew, contact, dispatch);
                } else {
                    contact.keepDoubleNumberByUser = true;
                    dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
                }
            });
        } catch (e) {
            console.error(e);
        }
    },

    updateStreetValue: function updateStreetValue(newStreetValue, deliveryAddress, deliveryAddressNew, contact, dispatch) {
        // remove comma and space on the end of string
        newStreetValue = newStreetValue.replace(/,?\s*$/, '');
        // for cases, when delivery address is modified 
        if (deliveryAddress && deliveryAddressNew) contact.deliveryAddress.street = contact.deliveryAddress.amountOfSquirrels = newStreetValue;
        // for  cases, when primary address is modified
        else contact.street = contact.amountOfSquirrels = newStreetValue;

        dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
    },

    getWarningAlertObject: function getWarningAlertObject(alertCaption, alertText) {
        return {
            text: alertText,
            type: 'warning',
            title: alertCaption,
            showCancelButton: true,
            cancelButtonText: Resx.Common.Keep,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: Resx.Common.Fix
        };
    },

    saveContact: function saveContact() {
        return function (dispatch, getState) {
            return new _promise2.default(function (resolve, reject) {
                dispatch(actions.validate(true));
                var state = getState();
                if (!state.customer.contactErrors.hasClientErrors) {
                    dispatch({ type: _actionTypes2.default.CONTACT_SAVING });
                    var contact = state.customer.contact;

                    var phoneCountryCode = _utils2.default.getPhoneCountryCode(state.cart.deliveryTypes.map(function (dt) {
                        return dt.collection[0];
                    }), state.cart.deliveryTypeId);
                    if ((contact.phoneNumberWithCode || '').length === 9 && phoneCountryCode) contact.phoneNumberWithCode = '+' + phoneCountryCode + contact.phoneNumberWithCode;

                    var model = toServerModel(contact);
                    model.hasShoppingConditionsConsent = state.cart.hasShoppingConditionsConsent;
                    model.hasCustomerReviewConsent = state.cart.hasCustomerReviewConsent;

                    return (contact.mode === _ContactForm.FormMode.registration ? customerService.register(model) : customerService.saveContactInfo(model)).done(function () {
                        dispatch({
                            type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
                                serverErrors: {},
                                hasServerErrors: false
                            }
                        });
                        resolve();
                    }).fail(function (err) {
                        if (err && err.responseJSON && err.responseJSON.error && err.responseJSON.error.validationErrors && err.responseJSON.error.validationErrors.find(function (x) {
                            return x.members.find(function (m) {
                                return m === "customerId";
                            });
                        })) {
                            reject({ reauthenticateAnonymousCustomer: true });
                        } else {
                            var serverErrors = {};
                            err.responseJSON && err.responseJSON.error.validationErrors && err.responseJSON.error.validationErrors.forEach(function (x) {
                                x.members.forEach(function (m) {
                                    serverErrors[m] = x.message;
                                });
                            });
                            dispatch({
                                type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
                                    serverErrors: serverErrors,
                                    hasServerErrors: true
                                }
                            });
                            reject();
                        }
                    });
                } else {
                    reject({ suppressError: true, detail: state.customer.contactErrors.clientErrors });
                }
            });
        };
    },
    validateDeliveryAddress: function validateDeliveryAddress(contact) {
        // this type of validation is oly for non-registered user using custom delivery address
        if (!contact || !contact.deliveryAddress || !contact.useCustomDeliveryAddress || contact.mode === 'registered') {
            return {};
        } else {
            return (0, _linksoftAlbatros.validateModel)(contact, {
                deliveryAddress: {
                    rocksEvolution: [_linksoftAlbatros.rules.required], // Name and surname
                    amountOfSquirrels: [_linksoftAlbatros.rules.required], // Street name
                    guardsOfOrange: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.postCode], // PostCode
                    jediPrayer: [_linksoftAlbatros.rules.required] // City
                }
            });
        }
    },
    validate: function validate(ignoreConsent) {
        return function (dispatch, getState) {
            var state = getState();
            var errors = (0, _linksoftAlbatros.validateModel)(state.customer.contact, getCustomerContactValidationRules(state.customer.contact, ignoreConsent));
            // append errors from delivery (secondary) address
            errors = (0, _extends3.default)({}, errors, actions.validateDeliveryAddress(state.customer.contact, errors));
            dispatch({
                type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
                    clientErrors: errors,
                    hasClientErrors: (0, _keys4.default)(errors).length > 0
                }
            });
        };
    }
};

_actions2.default.add('customer', actions);

exports.default = actions;


function toClientModel(model) {
    var invoicingAddress = model.invoicingAddress,
        deliveryAddressId = model.deliveryAddressId,
        companyNumber = model.companyNumber,
        vatNumber = model.vatNumber,
        rest = (0, _objectWithoutProperties3.default)(model, ['invoicingAddress', 'deliveryAddressId', 'companyNumber', 'vatNumber']);

    var _ref = invoicingAddress || {},
        companyName = _ref.companyName;

    return (0, _extends3.default)({}, (0, _pickBy2.default)((0, _extends3.default)({}, invoicingAddress || {}, rest, {
        deliveryAddressId: deliveryAddressId,
        companyName: companyName,
        companyNumber: companyNumber,
        vatNumber: vatNumber,
        companyIsFilledIn: !!(companyName || companyNumber || vatNumber),
        useCustomDeliveryAddress: !!deliveryAddressId
    })));
}

function toServerModel(model) {
    var email = model.email,
        phoneNumber = model.phoneNumber,
        phoneNumberWithCode = model.phoneNumberWithCode,
        firstName = model.firstName,
        lastName = model.lastName,
        street = model.street,
        city = model.city,
        postCode = model.postCode,
        countryId = model.countryId,
        companyIsFilledIn = model.companyIsFilledIn,
        companyName = model.companyName,
        companyNumber = model.companyNumber,
        vatNumber = model.vatNumber,
        useCustomDeliveryAddress = model.useCustomDeliveryAddress,
        deliveryAddress = model.deliveryAddress,
        deliveryAddressId = model.deliveryAddressId,
        mode = model.mode,
        password = model.password,
        passwordConfirm = model.passwordConfirm,
        subscribeToNewsletter = model.subscribeToNewsletter,
        subscribeToLoyaltyProgram = model.subscribeToLoyaltyProgram;


    var shouldSendCompanyInfo = mode === _ContactForm.FormMode.registered || companyIsFilledIn;

    return (0, _extends3.default)({}, shouldSendCompanyInfo ? { companyNumber: companyNumber, vatNumber: vatNumber } : {}, {

        email: email,
        phoneNumber: phoneNumber,
        phoneNumberWithCode: phoneNumberWithCode,
        firstName: firstName,
        lastName: lastName,

        invoicingAddress: (0, _extends3.default)({}, shouldSendCompanyInfo ? { companyName: companyName } : {}, {
            street: street,
            city: city,
            postCode: postCode,
            countryId: countryId
        }),
        deliveryAddressId: useCustomDeliveryAddress ? deliveryAddressId : null,
        deliveryAddress: useCustomDeliveryAddress && mode !== _ContactForm.FormMode.registered ? deliveryAddress : null
    }, mode === _ContactForm.FormMode.registration ? {
        password: password, passwordConfirm: passwordConfirm, subscribeToLoyaltyProgram: subscribeToLoyaltyProgram, subscribeToNewsletter: subscribeToNewsletter
    } : {});
}

function getCustomerContactValidationRules(model, ignoreConsent) {
    var validationModel = {
        email: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.emailAddress, _linksoftAlbatros.rules.isAsciiCompliant, emailSfValidation],
        phoneNumber: [_linksoftAlbatros.rules.required, phoneStrict],
        countryId: [_linksoftAlbatros.rules.required]
    };
    if (!ignoreConsent) validationModel.hasShoppingConditionsConsent = [validateCheckBox];

    var classicAddressPackage = {
        firstName: [_linksoftAlbatros.rules.required],
        street: [_linksoftAlbatros.rules.required],
        city: [_linksoftAlbatros.rules.required],
        postCode: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.postCode]
    };

    var passwordPackage = {
        password: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.password],
        passwordConfirm: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.compare('password')]
    };

    var honeyPotAddressPackage = {
        // honeypot funny input names
        gooseFederation: [_linksoftAlbatros.rules.required], // firstname
        hamsterPolice: [_linksoftAlbatros.rules.required], // lastname
        amountOfSquirrels: [_linksoftAlbatros.rules.required], // StreetAndHouseNumber
        guardsOfOrange: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.postCode], // PostCode
        jediPrayer: [_linksoftAlbatros.rules.required] // City
    };

    // this validation reads value assigned to global storage by smartform validation 
    // (smartformReact.js registerSfCallbacks - addValidationCallback)
    function emailSfValidation(value, model) {
        return _smartFormShared2.default.getTextByEmailValidationCode(model.emailValidationResult);
    }

    function phoneStrict(value) {
        return (/^[0-9]{9}$/.test(value) ? null : Resx.Validation.InvalidPhoneNumber
        );
    }

    function validateCheckBox(value) {
        return value ? null : Resx.Messages.NoShoppingConditionsConsent;
    }

    switch (model.mode) {
        case _ContactForm.FormMode.registered:
            validationModel = (0, _extends3.default)({}, validationModel, classicAddressPackage);
            if (model.useCustomDeliveryAddress) {
                validationModel.deliveryAddressId = [_linksoftAlbatros.rules.required];
            }
            break;
        case _ContactForm.FormMode.registration:
            validationModel = (0, _extends3.default)({}, validationModel, passwordPackage, honeyPotAddressPackage);
            break;
        case _ContactForm.FormMode.anonymous:
            validationModel = (0, _extends3.default)({}, validationModel, honeyPotAddressPackage);
            break;
    }

    return validationModel;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customer/actions.js
// module id = 198
// module chunks = 0 2